module.exports = __webpack_public_path__ + "static/media/shortlink2.a2433735.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Creating/shortlink2.jpg
// module id = 1621
// module chunks = 0